import React, { Fragment } from "react";
import PropTypes from "prop-types";

import DesktopProjectPage from "components/Project/DesktopProjectPage";

import localize from "lang/localize";

const propTypes = {
  topics: PropTypes.array.isRequired,
  more: PropTypes.bool,
  renderProjectPanel: PropTypes.func,
  renderProjectUserPanel: PropTypes.func,
  renderTopics: PropTypes.func,
  handleMore: PropTypes.func
};

class CustomDesktopProjectPage extends DesktopProjectPage {
  render() {
    return (
      <Fragment>
        <div className="pure-u-14-24 on-md-rightpadding-10 flex">
          {this.props.renderProjectPanel()}
        </div>
        <div className="pure-u-10-24 on-md-leftpadding-10 flex">
          {this.props.renderProjectUserPanel()}
        </div>
        <div className="pure-u-1-1 topmargin">
          {this.props.renderTopics(this.props.topics, false)}
        </div>
        {this.props.more && (
          <div className="pure-u-1-1 topmargin">
            <button
              className="button automargin"
              onClick={this.props.handleMore}
            >
              {localize("more_text", this.props.language)}
            </button>
          </div>
        )}
      </Fragment>
    );
  }
}

CustomDesktopProjectPage.propTypes = propTypes;

export default CustomDesktopProjectPage;
